(ns manage.content-configuration-page.context-source.custom
  (:require [common.ui.list :as ui.list]
            [common.ui.validation.db :refer [validation-schema]]
            [manage.content-configuration-page.context-source.shared :as cs]
            [manage.content-configuration-page.view.list :as lv]
            [re-frame.core :as rf]
            [re-posh.core :as rp]
            [uix.core :refer [$]]))

(def schema-id "urn:lemonpi:schema:context:custom:v1")

;; database

(defn custom-schema-selector [ccs selector]
  {:custom-context-source/_selector ccs
   ;; setting :custom-schema-selector/owner-id is a workaround for not being able to
   ;; use :custom-context-source/_selector in a tuple attribute
   :custom-schema-selector/owner-id ccs
   :custom-schema-selector/name selector})

(rp/reg-event-ds :custom-context-source/create-selector
  (fn [_ [_ ccs selector]]
    [(custom-schema-selector ccs selector)]))

(defmethod cs/parameter schema-id
  [{selectors :custom-context-source/selector}]
  (map :custom-schema-selector/name selectors))

(defmethod cs/context->constructor schema-id
  [{:keys [alias param]}]
  {:custom-context-source/selector
   (map (partial custom-schema-selector [:context-source/alias alias]) param)})

(defmethod validation-schema :custom-schema-selector/name
  [_schema value]
  {:validation/schema :context-source/alias
   :validation/value value})

;; UI

(defn entity-view-cfg-custom-selector [cs]
  {:entity/ref cs
   :entity/label :custom-schema-selector/name
   :validation/schema :context-source})

(defmethod cs/entity-view-cfg schema-id
  [ccs]
  (merge
   (cs/entity-view-cfg-base ccs)
   {:list-item/details [cs/configure-button ccs "rule" "Configure custom selector"]
    :entity/content
    [lv/view
     {:entity/ref ccs
      :list/add-item-cfg
      {:add-item/label "Add custom selector"
       :add-item/new-value [:add-item/suggest-name :custom-schema-selector/name "selector"]
       :validation/schema
       [:and
        [:string {:error/message
                  "A selector should be between 1 and 16 characters long."
                  :min 1 :max 16}]
        [:re {:error/message "A selector should only contain letters, digits , '-' and '_'."}
         #"^[\w-_]+$"]]
       :add-item/add-fn #(rf/dispatch [:custom-context-source/create-selector (:eid ccs) %])}
      :list/items :custom-context-source/selector
      :list/->item-cfg entity-view-cfg-custom-selector
      :list/empty-msg ($ ui.list/empty-msg {:title "Add Custom selectors"}
                         ($ :p
                            "You can add custom selectors to create content-groups for your DCP setups."))}]}))

(defmethod cs/entity-query-params schema-id
  [{:keys [alias]}]
  (cs/alias->entity-query-params alias))
